import { getTextField } from '@lender/utils';
import _ from 'lodash';

import { FieldInputTypeValidation } from 'constants/formGenerator';
import { MiCompanyType } from 'constants/loanApplication';
import { getConditionalObject } from 'utils/data';

import {
  MI_ORDER_OUTCOME_FIELD_IDS,
  MI_STORED_VALUE_CLEARED_MESSAGE,
} from './MortgageInsurance.constants';

const isBlankValue = value => _.isNil(value) || value === '';

// The backend keeps the stored MI number/date on null, so a cleared field would save as a silent no-op.
const getNotClearableSchema = baseSchema => validationProps =>
  baseSchema(validationProps).test(
    'mi-stored-value-not-cleared',
    MI_STORED_VALUE_CLEARED_MESSAGE,
    value => !isBlankValue(value),
  );

const withStoredValueGuard = storedValues => field => {
  if (_.isNil(storedValues?.[field.fieldId])) {
    return field;
  }

  const baseSchema = FieldInputTypeValidation[field.inputProps.type] ?? getTextField;

  return {
    ...field,
    inputProps: {
      ...field.inputProps,
      customSchema: getNotClearableSchema(baseSchema),
    },
  };
};

export const withStoredValueGuards = (storedValues, fields) =>
  fields.map(withStoredValueGuard(storedValues));

const disableOrderOutcomeField = field =>
  MI_ORDER_OUTCOME_FIELD_IDS.includes(field.fieldId)
    ? { ...field, inputProps: { ...field.inputProps, disabled: true } }
    : field;

// The backend drops insurer-outcome writes from non-employee (broker) callers, so edits there would be lost.
export const withReadOnlyOrderOutcome = (isOrderOutcomeReadOnly, groups) =>
  isOrderOutcomeReadOnly
    ? groups.map(group => ({ ...group, fields: group.fields.map(disableOrderOutcomeField) }))
    : groups;

export const buildMiCompanyTypeChangeHandler =
  ({ hasCompanyOtherDescription, setMultipleInForm, validateField }) =>
  (__, option) => {
    const companyType = option || '';
    const shouldClearOtherDescription =
      hasCompanyOtherDescription && option?.value !== MiCompanyType.OTHER;

    setMultipleInForm({
      miCompanyType: companyType,
      ...getConditionalObject(shouldClearOtherDescription, { miCompanyOtherDescription: null }),
    });
    validateField('miCompanyType', companyType);
  };
